import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { FusePageCarded } from '@fuse';
import { withRouter } from 'react-router-dom'
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as Actions from './store/actions';
import { Button, Tab, Tabs, Grid, Divider, DialogTitle, DialogContent, DialogActions, Dialog } from '@material-ui/core';
import * as validatorActions from '../../components/validator/store/actions';
import * as _ from 'lodash';
import NotificationForm from './NotificationForm';
import TabPanelButtons from '../../components/TabPanelButtons';
import NotificationAuthList from './NotificationAuthList';

const styles = theme => ({
    layoutRoot: {},
    layoutToolbar: {
        padding: 0
    },
    tabsRoot: {
        height: 64,
        flex: 1
    },
    tabRoot: {
        height: 64,
        [theme.breakpoints.up('md')]: {
            minWidth: '144px'
        }
    },
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    textField: {
        marginLeft: theme.spacing.unit,
        marginRight: theme.spacing.unit,
        width: '80%',
    },
    textFieldSearch: {
        marginLeft: theme.spacing.unit,
        width: '95%',
    },
    button: {
        margin: theme.spacing.unit,
        minWidth: '80%',
        maxWidth: '80%'
    },
});

class Notification extends Component {
    state = {
        current_tab: 0,
        notification_id: 0,
        view_type: '',
        tabValue: 0,
        deleteDialogActive: false
    }

    constructor(props) {
        super(props);

        const notification_id = this.props.match.params.notification_id;
        const view_type = this.props.match.params.view_type;

        this.state = {
            ...this.state,
            notification_id: notification_id,
            view_type: view_type,
        }
        this.props.getNotificationData(notification_id);
        this.props.updateNotificationLoaded(false);
    }

    componentDidUpdate = (prevProps, prevState) => {
        const notification_id = this.props.match.params.notification_id;
        if (
            !_.isEqual(notification_id, prevProps.match.params.notification_id)
        ) {
            this.setState({
                ...this.state,
                notification_id
            })
            this.props.getNotificationData(notification_id)
        }
    }

    componentWillUnmount = () => {
        const noteType = this.props.currentNotification.NotificationType
        const student_event = (noteType === 'retake_event' || noteType === 'retake_approval' || noteType === 'late_event' || noteType === 'instructor_note' )
        this.props.setNotificationReference({
            notification_id: 0,
            NotificationHeader: '',
            NotificationContent: '',
            NotificationReference: '',
            NotificationReferenceID: 0,
            instructor_id: 0,
            AuthList: []
        });
        if (this.props.auth.user.role !== 'student' && !student_event) {
            const notification_rel = this.props.currentNotification.AuthList.find(a => a.auth_id === this.props.auth.user.data.auth_id);
            if (notification_rel) {
                this.props.resolveNotification(notification_rel.notification_relation_id)
            }
        }
        
    }

    componentWillReceiveProps = (props) => {
        if (this.state.view_type === 'detail' && props.currentNotification.notification_id != 0) {
            const authNotification = props.currentNotification.AuthList.filter(n => n.auth_id === props.auth.user.data.auth_id)
            if (authNotification.length > 0) {
                if (authNotification.filter(n => n.Viewed === 0).length > 0) {
                    this.props.authViewNotification(props.auth.user.data.auth_id, props.currentNotification.notification_id)
                }
            }
        }
    }

    handleSubmit = () => {
        const auth_id = this.props.auth.user.data.auth_id;
        switch (this.state.view_type) {
            case ("create"):
                {
                    this.props.saveNotification(this.props.currentNotification);

                    this.props.history.goBack()
                    break;
                }

            case ("edit"):
                {
                    this.props.saveNotification(this.props.currentNotification);

                    this.props.history.goBack()
                    break;
                }

            default:
                {

                }
        }
    }

    handleDeleteDialogOpen = () => {
        this.setState({ deleteDialogActive: true })
    }

    handleDelete = () => {
        switch (this.state.view_type) {
            case ("edit"):
                {
                    this.props.deleteNotification(this.props.currentNotification.notification_id);
                    this.props.history.goBack();
                    break;
                }

            default:
                {

                }

        }
    }

    handleChangeTab = (event, value) => {
        this.setState({
            ...this.state,
            current_tab: value
        })
    }

    getPageContent = (current_tab, view_type) => {
        const { classes, currentNotification, theme } = this.props;

        switch (current_tab) {
            case (0):
                {
                    return (
                        <NotificationForm
                            currentNotification={currentNotification}
                            view_type={view_type}
                        />
                    )
                }
            case (1):
                {
                    return (
                        <NotificationAuthList
                            AuthList={currentNotification.AuthList}
                        />
                    )
                }
        }

    }

    getDeleteDialog = (active, notification) => {
        return (
            <Dialog
                open={active}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                onBackdropClick={() => this.setState({ deleteDialogActive: false })}
            >
                <DialogTitle>Confirm Delete {notification.NotificationHeader}?</DialogTitle>
                <DialogContent>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => this.handleDelete()} color="primary">
                        Delete
                    </Button>
                    <Button onClick={() => this.setState({ deleteDialogActive: false })} color="primary" autoFocus>
                        Go Back
                    </Button>
                </DialogActions>
            </Dialog>

        )
    }

    handleResolve = (notification) => {
        switch (notification.NotificationReference) {
            case ('scheduled_course'):
            case ('company_calendar_course'):
                {
                    this.props.resolveNotification(notification.notification_relation_id);
                    return this.props.history.push('/dashboard');
                }
            case ('student_assignment'):
                {
                    return this.props.history.push('/assignment/student/' + notification.NotificationReferenceID)
                }
            case ('student_quiz'):
                {
                    if (notification.NotificationType === 'instructor_note') {
                        const unresolvedNotification = notification.AuthList.filter(n => n.Resolved === 0)
                        unresolvedNotification.length > 0 ? this.props.resolveNotification(unresolvedNotification[0].notification_relation_id) : null

                        return this.props.history.push('/quiz/score/' + notification.NotificationReferenceID)
                    }
                    return this.props.history.push('/quiz/student/' + notification.NotificationReferenceID)
                }
            default:
                {
                    return null
                }
        }

    }

    render() {
        const { classes, isNotificationLoaded, auth } = this.props;
        const { current_tab, view_type } = this.state;
        const delete_dialog = this.getDeleteDialog(this.state.deleteDialogActive, this.props.currentNotification)
        const resolveButton = (notification) => {
            if (auth.user.role != 'student') {
                return null
            }
            switch (notification.NotificationReference) {
                case ('scheduled_course'):
                case ('company_calendar_course'):
                    {
                        return (
                            <Button color="primary" variant="contained" onClick={() => this.handleResolve(notification)} >Dismiss</Button>
                        )
                    }
                case ('student_assignment'):
                    {
                        return (
                            <Button color="primary" variant="contained" onClick={() => this.handleResolve(notification)} >Go To Assignment</Button>
                        )
                    }
                case ('student_quiz'):
                    {
                        return (
                            <Button color="primary" variant="contained" onClick={() => this.handleResolve(notification)} >Go To Quiz</Button>
                        )
                    }

            }

            return null
        }

        // console.log(this.props.currentNotification)

        if (!isNotificationLoaded) {
            return <div>loading</div>
        }

        let page_content = <React.Fragment>Loading...</React.Fragment>;
        if (isNotificationLoaded) {
            page_content = this.getPageContent(current_tab, view_type);
        }

        return (
            <FusePageCarded
                classes={{
                    root: classes.layoutRoot,
                    toolbar: classes.layoutToolbar
                }}
                header={
                    <div className="py-24"><h4>{'Notification ' + (view_type.charAt(0).toUpperCase() + view_type.slice(1))}</h4></div>
                }
                contentToolbar={
                    <div style={{ width: '100%', height: '100%', }}>
                        {/* The div below is only for properly pushing the buttons to the right in lieu of tabs. If tabs get added, delete this div. */}
                        <Grid container>
                            <Tabs
                                value={current_tab}
                                onChange={this.handleChangeTab}
                                indicatorColor="primary"
                                textColor="primary"
                                classes={{
                                    root: classes.tabsRoot
                                }}
                                scrollable={true}
                            >
                                <Tab
                                    classes={{
                                        root: classes.tabRoot
                                    }}
                                    label="Detail"
                                />
                                <Tab
                                    classes={{
                                        root: classes.tabRoot
                                    }}
                                    label="Views"
                                    hidden={view_type != 'edit'}
                                />
                            </Tabs>

                            <TabPanelButtons
                                component_name={"notification"}
                                view_type={view_type}
                                button_list={[
                                    {
                                        display: "Save",
                                        type: "update",
                                        onClick: this.handleSubmit,
                                        overridePermission: true,
                                    },
                                    {
                                        type: "delete",
                                        onClick: this.handleDeleteDialogOpen,
                                        overridePermission: true,
                                    },
                                    {
                                        type: "back",
                                        onClick: this.props.history.goBack,
                                    }
                                ]}
                            />
                        </Grid>
                    </div>

                }
                content={
                    <React.Fragment>
                        <div className="p-24">
                            {delete_dialog}
                            {page_content}
                            {resolveButton(this.props.currentNotification)}
                        </div>
                        {/* <div className="p-24">
                            {button_content}
                        </div> */}
                    </React.Fragment>
                }
            />
        )
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        updateNotificationLoaded: Actions.updateNotificationLoaded,
        updateNotificationForm: Actions.updateNotificationForm,
        getNotificationData: Actions.getNotificationData,
        saveNotification: Actions.saveNotification,
        deleteNotification: Actions.deleteNotification,
        setNotificationReference: Actions.setNotificationReference,
        authViewNotification: Actions.authViewNotification,
        resolveNotification: Actions.resolveNotification,
    }, dispatch);
}

function mapStateToProps({ notification, auth }) {
    return {
        currentNotification: notification.currentNotification,
        isNotificationLoaded: notification.isNotificationLoaded,
        auth
    }
}

export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(Notification)));



// WEBPACK FOOTER //
// src/main/content/notification/Notification.js